import React from "react";
import SubmitButtons from "@@components/SubmitButtons";
import { Account } from "../../../../../monorepo/packages/graphql";
import CoverLetter from "./CoverLetter";
import UploadAttachments from "./UploadAttachments";
import { Authorization } from "@samacare/graphql";

interface AttachmentsProps {
  onBack: () => void;
  onSubmit: () => void;
  onCheckboxChange: (b: boolean) => void;
  checkboxValue: boolean;
  coverLetterNote: string;
  setCoverLetterNote: (s: string) => void;
  attachments: [];
  account: Account;
  authorization: Authorization;
  showEMRDocumentOption: boolean;
  disabled: boolean;
  openEditCoverLetterModal: () => void;
}

const Attachments: (props: AttachmentsProps) => JSX.Element = ({
  onBack,
  onSubmit,
  onCheckboxChange,
  checkboxValue,
  coverLetterNote,
  setCoverLetterNote,
  attachments,
  account,
  authorization,
  showEMRDocumentOption,
  disabled,
  openEditCoverLetterModal,
}: AttachmentsProps) => {
  return (
    <div style={{ marginTop: "16px", maxWidth: "684px" }}>
      <CoverLetter
        onCheckboxChange={onCheckboxChange}
        checkboxValue={checkboxValue}
        coverLetterNote={coverLetterNote}
        setCoverLetterNote={setCoverLetterNote}
        disabled={disabled}
        openEditModal={openEditCoverLetterModal}
      />
      <UploadAttachments
        attachments={attachments}
        account={account}
        authorization={authorization}
        showEMRDocumentOption={showEMRDocumentOption}
        multiple={true}
        header="Attachments"
        details="Attach additional documents (optional)"
        hideUploader={disabled}
        disabled={disabled}
      />
      <SubmitButtons
        back={onBack}
        submit={onSubmit}
        submitText="Review and Submit"
      />
    </div>
  );
};

export default Attachments;
